import React from 'react';
import Header from '../Header';
import Footer from '../Footer';

class Navigation extends React.Component {
  render() {
    const { children, showFooter } = this.props;
    return (
      <React.Fragment>
        <Header />
        {children}
        {(showFooter) ? <Footer /> : null}
      </React.Fragment>
    );
  }
}

export default Navigation;